import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/auth/_auth-layout")({
  component: () => (
    <div className="relative min-h-screen overflow-x-hidden bg-pageBackground">
      <div className="pointer-events-none absolute -left-24 top-0 h-72 w-72 rounded-full bg-volume-mid-purple/70 blur-3xl" />
      <div className="pointer-events-none absolute -right-28 bottom-0 h-96 w-96 rounded-full bg-volume-light-purple blur-3xl" />
      <div className="relative flex min-h-screen items-start justify-center px-4 py-10 sm:items-center">
        <div className="w-full max-w-md">
          <Outlet />
        </div>
      </div>
    </div>
  ),
});
